import Repository from '../Repository';

export default {

	getNumberOfUnallocatedPapers() {

		var response = Repository.get('Report/GetNumberOfUnallocatedPapers', {
			/*params: {
				qualificationId: qualificationId,	
			}*/
		});
		return response;
	},

	getQuestionLevelMarks(pageSize, pageNumber, searchString, periodIds, subPeriodIds, qualificationIds, subjectIds, languageIds, assessmentTypeIds, assessmentCodeIds) {
		let response = Repository.get('Report/GetQuestionLevelMarks', { 
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,
				SearchString: searchString,
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				LanguageIdCSV: (languageIds == null) ? null : languageIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(',')
			}
		});
		return response;
	},

	getQuestionLevelMarksCsv(searchString, periodIds, subPeriodIds, qualificationIds, subjectIds, languageIds, assessmentTypeIds, assessmentCodeIds) {
		let response = Repository.get('Report/GetQuestionLevelMarksCsv', { 
			params: {
				SearchString: searchString,
				PeriodIdCSV: (periodIds == null) ? null : periodIds.join(','),
				SubPeriodIdCSV: (subPeriodIds == null) ? null : subPeriodIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				LanguageIdCSV: (languageIds == null) ? null : languageIds.join(','),
				AssessmentTypeIdCSV: (assessmentTypeIds == null) ? null : assessmentTypeIds.join(','),
				AssessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				Csv: true			
			}
		});
		return response;
	},

}
